import { useMemo } from 'react'
import { Heading } from '@pancakeswap/uikit'
import Page from 'components/Layout/Page'
import PoolTable from 'views/Info/components/InfoTables/PoolsTable'
import { useAllPoolData } from 'state/info/hooks'
// import { useWatchlistPools } from 'state/user/hooks'
import { useTranslation } from 'contexts/Localization'
import { isSecurityToken } from 'config/constants/tokens'

const PoolsOverview: React.FC = () => {
  const { t } = useTranslation()

  // get all the pool datas that exist
  const allPoolData = useAllPoolData()
  const poolDatas = useMemo(() => {
    return Object.values(allPoolData)
      .map((pool) => pool.data)
      .filter((pool) => pool)
  }, [allPoolData])

  const digitalPools = poolDatas.filter((pool) => {
    return !isSecurityToken(pool.token0.address) && !isSecurityToken(pool.token1.address) && pool.liquidityUSD > 500.0
  })

  const securityPools = poolDatas.filter((pool) => {
    return (isSecurityToken(pool.token0.address) || isSecurityToken(pool.token1.address)) && pool.liquidityUSD > 700.0
  })

  return (
    <Page>
      {/* <Heading scale="lg" mb="16px">
        {t('Your Watchlist')}
      </Heading>
      <Card>
        {watchlistPools.length > 0 ? (
          <PoolTable poolDatas={watchlistPools} />
        ) : (
          <Text px="24px" py="16px">
            {t('Saved pools will appear here')}
          </Text>
        )}
      </Card> */}

      <Heading scale="lg" mt="40px" mb="16px" id="info-pools-title">
        {t('Security Tokens Pools')}
      </Heading>
      <PoolTable poolDatas={securityPools} />

      <Heading scale="lg" mt="40px" mb="16px" id="info-pools-title">
        {t('Digital Assets Pools')}
      </Heading>
      <PoolTable poolDatas={digitalPools} />
    </Page>
  )
}

export default PoolsOverview
